// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__32xqP","bigColWidth":"Table_bigColWidth__3mTBe","biggerColWidth":"Table_biggerColWidth__31Wem","row":"Table_row__1yatl","col":"Table_col__2IdPy"};